import { useEffect, useRef } from 'react';

import { useCollapseSidebarIfExpanded } from './useSidebarMode';

// creating the existing behavior of clicking outside the sidebar to close it when expanded
// https://dev.to/rashed_iqbal/how-to-handle-outside-clicks-in-react-with-typescript-4lmc
export const useOutsideClickRef = () => {
  const ref = useRef<HTMLDivElement>(null);
  const collapseSidebarIfExpanded = useCollapseSidebarIfExpanded();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        collapseSidebarIfExpanded();
      }
    };

    document.addEventListener('mouseup', handleClickOutside);
    document.addEventListener('touchend', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, [collapseSidebarIfExpanded]);

  return ref;
};
